import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['header'];
  static values = {
    offsetElement: String, // CSS selector for element whose height to use as offset
    offset: { type: Number, default: 0 }, // Fixed pixel offset
  };

  connect() {
    // Set up header styles immediately to prevent flash of unstyled content
    // Primary headers (no offset) get higher z-index than secondary headers (with offset)
    const zIndex =
      this.hasOffsetElementValue && this.offsetElementValue ? '9' : '10';

    this.headerTargets.forEach((header) => {
      header.style.position = 'relative';
      header.style.zIndex = zIndex;
      header.style.willChange = 'transform';
    });

    // Call fixHeader immediately (synchronously) to set initial position
    this.fixHeader();

    window.addEventListener('resize', this.fixHeader);

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.updateHeader();
        } else {
          this.removeHeaderUpdate();
        }
      },
      {
        rootMargin: `0px 0px -100%`,
      }
    );

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.unobserve(this.element);
    window.removeEventListener('resize', this.fixHeader);
    window.removeEventListener('scroll', this.fixHeader);
  }

  updateHeader() {
    window.addEventListener('scroll', this.fixHeader);
  }

  removeHeaderUpdate() {
    window.removeEventListener('scroll', this.fixHeader);
  }

  fixHeader = () => {
    const elDistanceFromTop =
      window.pageYOffset + this.element.getBoundingClientRect().top;
    let position = window.pageYOffset - elDistanceFromTop;

    if (position < 0) {
      position = 0;
    }

    // Only add offset when actually stuck (scrolling past the element)
    if (position > 0) {
      const offset = this.calculateOffset();
      position += offset;
    }

    this.headerTargets.forEach((header) => {
      header.style.transform = `translateY(${position}px)`;
    });
  };

  calculateOffset() {
    if (this.hasOffsetElementValue && this.offsetElementValue) {
      const offsetEl = document.querySelector(this.offsetElementValue);
      if (offsetEl) {
        return offsetEl.getBoundingClientRect().height - 2;
      }
    }
    return this.offsetValue;
  }
}
